import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '../components/ui/Tooltip';

interface PilotEventBadgeProps {
  eventId: string;
  eventName: string;
  pilotFirstNames: string[];
}

/**
 * Day-header chip showing one event with all pilots assigned to it on that
 * day — `Eldora Speedway · Riley, Casey`. Click navigates to the event detail.
 *
 * Grouping by event (rather than one chip per pilot) keeps the header
 * readable when several pilots double up on the same show, and matches the
 * way the pilot team thinks about assignments — by show first, by person
 * second.
 */
const PilotBadge: React.FC<PilotEventBadgeProps> = ({ eventId, eventName, pilotFirstNames }) => {
  const names = (pilotFirstNames ?? []).join(', ');
  return (
    <Tooltip label={`${names} — ${eventName}`}>
    <Link
      to={`/events/${eventId}`}
      className="inline-flex items-center gap-1.5 max-w-full px-2 py-0.5 rounded-full
                 text-[10px] font-medium
                 bg-sky-500/15 text-sky-300 ring-1 ring-inset ring-sky-500/25
                 hover:bg-sky-500/25 hover:text-sky-200 transition-colors"
    >
      <span className="font-semibold truncate">{names}</span>
      <span className="text-sky-400/60">·</span>
      <span className="truncate text-sky-200/90">{eventName}</span>
    </Link>
    </Tooltip>
  );
};

export default PilotBadge;
